import { alpha3ToAlpha2 } from "@utils/countryCodeMap";

export const normalizeAlpha2 = (code) => {
  if (!code || typeof code !== "string") return "";

  const trimmed = code.trim();

  if (trimmed.length !== 2) return "";

  return trimmed.toUpperCase();
};

export const toAlpha2CountryCode = (newValue, countries = []) => {
  if (!newValue) return "";

  if (typeof newValue === "string") {
    const fromAlpha2 = normalizeAlpha2(newValue);

    if (fromAlpha2) return fromAlpha2;

    const alpha3 = newValue.trim();

    if (alpha3.length === 3) {
      const mapped = alpha3ToAlpha2[alpha3.toUpperCase()];
      const mappedAlpha2 = normalizeAlpha2(mapped);

      if (mappedAlpha2) return mappedAlpha2;
    }

    const countryItem =
      countries.find((c) => c.code === newValue) ||
      countries.find(
        (c) =>
          c.code_alpha2 === newValue ||
          c.alpha2 === newValue ||
          c.iso2 === newValue ||
          c.code2 === newValue,
      );

    const fromItem =
      normalizeAlpha2(countryItem?.code_alpha2) ||
      normalizeAlpha2(countryItem?.alpha2) ||
      normalizeAlpha2(countryItem?.iso2) ||
      normalizeAlpha2(countryItem?.code2) ||
      normalizeAlpha2(countryItem?.code);

    return fromItem || "";
  }

  const direct =
    newValue.code_alpha2 ||
    newValue.alpha2 ||
    newValue.iso2 ||
    newValue.code2 ||
    "";

  const directAlpha2 = normalizeAlpha2(direct);

  if (directAlpha2) return directAlpha2;

  const codeAlpha2 = normalizeAlpha2(newValue.code);

  if (codeAlpha2) return codeAlpha2;

  if (typeof newValue.code === "string" && newValue.code.length === 3) {
    const mapped = alpha3ToAlpha2[newValue.code.toUpperCase()];
    const mappedAlpha2 = normalizeAlpha2(mapped);

    if (mappedAlpha2) return mappedAlpha2;

    const by3 =
      countries.find((c) => c.code === newValue.code) ||
      countries.find(
        (c) =>
          c.code_alpha3 === newValue.code ||
          c.alpha3 === newValue.code ||
          c.iso3 === newValue.code,
      );

    const alpha2 =
      by3?.code_alpha2 ||
      by3?.alpha2 ||
      by3?.iso2 ||
      by3?.code2 ||
      (typeof by3?.code === "string" && by3.code.length === 2
        ? by3.code
        : "");

    const alpha2Normalized = normalizeAlpha2(alpha2);

    if (alpha2Normalized) return alpha2Normalized;
  }

  return "";
};

export const findCountryByAlpha2 = (alpha2Code, countries = []) => {
  const normalized = normalizeAlpha2(alpha2Code);

  if (!normalized) return null;

  const deriveAlpha2FromCountryItem = (country) => {
    const direct =
      normalizeAlpha2(country.code_alpha2) ||
      normalizeAlpha2(country.alpha2) ||
      normalizeAlpha2(country.iso2) ||
      normalizeAlpha2(country.code2) ||
      normalizeAlpha2(country.code);

    if (direct) return direct;

    if (typeof country.code === "string" && country.code.trim().length === 3) {
      const mapped = alpha3ToAlpha2[country.code.trim().toUpperCase()];
      return normalizeAlpha2(mapped) || "";
    }

    return "";
  };

  return (
    countries.find((country) => normalizeAlpha2(country.code) === normalized) ||
    countries.find(
      (country) => normalizeAlpha2(country.code_alpha2) === normalized,
    ) ||
    countries.find(
      (country) => normalizeAlpha2(country.alpha2) === normalized,
    ) ||
    countries.find((country) => normalizeAlpha2(country.iso2) === normalized) ||
    countries.find((country) => normalizeAlpha2(country.code2) === normalized) ||
    countries.find(
      (country) => deriveAlpha2FromCountryItem(country) === normalized,
    ) ||
    null
  );
};